import Vue from 'vue';
import api from '../bu/api';

export default {
	namespaced: true,

	state: () => ({
		categories: {},
		categoriesArray: []
	}),

	getters: {
		categories(state) {
			return state.categoriesArray;
		},
		categoryMap(state) {
			return state.categories;
		}
	},

	actions: {
		async getAllCategories({commit}) {
			const response = await api.getAllItemCategories();
			commit('setCategories', response.data);
			return response.data.map((item) => item.id);
		},
		async saveCategory({commit}, category) {
			const response = await api.saveItemCategory(category);
			commit('setCategory', response.data);
		},
		async deleteCategory({commit}, categoryId) {
			await api.deleteItemCategory(categoryId);
			commit('deleteCategory', categoryId);
		}
	},

	mutations: {
		setCategory(state, category) {
			Vue.set(state.categories, category.id, category);
			Vue.set(state, 'categoriesArray', Object.values(state.categories));
		},
		setCategories(state, categories) {
			categories.forEach((i) => {
				Vue.set(state.categories, i.id, i);
			});
			Vue.set(state, 'categoriesArray', Object.values(state.categories));
		},
		deleteCategory(state, categoryId) {
			Vue.delete(state.categories, categoryId);
			Vue.set(state, 'categoriesArray', Object.values(state.categories));
		}
	},
}